import { render, staticRenderFns } from "./TasksWidget.vue?vue&type=template&id=2b429412&scoped=true&"
import script from "./TasksWidget.vue?vue&type=script&lang=js&"
export * from "./TasksWidget.vue?vue&type=script&lang=js&"
import style0 from "./TasksWidget.vue?vue&type=style&index=0&id=2b429412&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b429412",
  null
  
)

export default component.exports